import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=bdbbe8be&scoped=true&lang=pug&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.scss?vue&type=style&index=0&id=bdbbe8be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbbe8be",
  null
  
)

export default component.exports